import _objectSpread from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import currency from '../../constants/currencyConstants.js';
import paymentMethodTypes from '../../constants/paymentMethodTypeConstants.js';
var colours = {
  black: '#141414',
  error100: '#cc1426',
  grey5: '#f3f3f3',
  grey15: '#d8d8d8',
  grey50: '#7f7f7f',
  grey83: '#2b2b2b',
  white: '#fff'
};
var fontSize = '16px';
var fontWeight = '400';
var appearance = {
  theme: 'flat',
  variables: {
    accessibleColorOnColorPrimary: colours.grey83,
    accordionItemSpacing: '8px',
    borderRadius: '0',
    colorBackground: colours.white,
    fontFamily: '"GillSansforJL", "Gill Sans", "Gill Sans MT", "GillSansMTStd-Medium", Avenir, Corbel, Arial, Helvetica, sans-serif',
    fontLineHeight: '1.5'
  },
  rules: {
    '.Block': {
      boxShadow: 'none',
      padding: '12px'
    },
    '.AccordionItem': {
      border: "1px solid ".concat(colours.grey15),
      fontSize: fontSize,
      fontWeight: fontWeight,
      padding: '20px 20px 16px 20px'
    },
    '.AccordionItem--selected': {
      borderColor: colours.black,
      color: colours.black
    },
    '.Error': {
      fontSize: fontSize,
      fontWeight: fontWeight,
      marginTop: '8px'
    },
    '.Label': {
      color: colours.black,
      fontSize: fontSize,
      fontWeight: fontWeight,
      lineHeight: '22px',
      marginBottom: '8px'
    },
    '.Input': {
      border: "1px solid ".concat(colours.grey50),
      borderRadius: '2px',
      boxShadow: 'none',
      padding: '14px 12px'
    },
    '.Input:focus': {
      boxShadow: "inset 0 0 0 1px ".concat(colours.black),
      outline: 'none'
    },
    '.Input:focus, .Input:hover': {
      borderColor: colours.black,
      borderRadius: '4px',
      borderWidth: '1px'
    },
    '.Input--invalid, .Input--invalid:focus, .Input--invalid:hover': {
      borderColor: colours.error100,
      borderWidth: '1px',
      boxShadow: 'none'
    },
    '.Input:disabled, .Input--invalid:disabled': {
      color: colours.grey5
    }
  }
};
var stripeOptions = function stripeOptions(_ref) {
  var amount = _ref.amount,
    _ref$paymentMethodTyp = _ref.paymentMethodType,
    paymentMethodType = _ref$paymentMethodTyp === void 0 ? paymentMethodTypes.CARD : _ref$paymentMethodTyp;
  var resolvedPaymentMethodTypes = ['card'];
  var includePaymentMethodCreation = true;
  switch (paymentMethodType) {
    case paymentMethodTypes.KLARNA:
      resolvedPaymentMethodTypes = ['klarna'];
      includePaymentMethodCreation = false;
      break;
    case paymentMethodTypes.EXPRESS_ELIGIBLE:
      resolvedPaymentMethodTypes = ['card', 'klarna'];
      includePaymentMethodCreation = false;
      break;
  }
  return _objectSpread(_objectSpread({
    allowedCardBrands: ['visa', 'mastercard', 'american_express'],
    amount: amount,
    appearance: appearance,
    currency: currency.LOWER,
    loader: 'never',
    mode: 'payment'
  }, includePaymentMethodCreation && {
    paymentMethodCreation: 'manual'
  }), {}, {
    paymentMethodTypes: resolvedPaymentMethodTypes
  });
};
export { stripeOptions };